import { render, staticRenderFns } from "./StudentAffairsEntry.vue?vue&type=template&id=3d9688ea&"
import script from "./StudentAffairsEntry.vue?vue&type=script&lang=js&"
export * from "./StudentAffairsEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports